import { handleResponse, authHeader } from '../helpers';

const BASE_URL = process.env.REACT_APP_API_URL;

export const campaignService = {
    getRuleTypes,
    saveCampaign,
    saveOrder,
};

function getRuleTypes(start) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/campaigns/all-data` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function saveCampaign(campaign) {
    //pre-process the rules into a string - comma seperated
    let rules = [];
    campaign.Rules.forEach((r, ix) => {
        if (typeof r.Values !== 'string') {
            rules[ix] = { CampaignID: r.CampaignID,
                          TypeID: r.TypeID,
                          Values: r.Values.join(',') };
        } else {
          rules[ix] = r;
        }
    })
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({
            ID: campaign.ID,
            Name: campaign.Name,
            Active: campaign.Active,
            Rules: rules,
        })
    };
    return fetch(`${BASE_URL}/campaigns/save` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function saveOrder(campaigns) {
    let data = JSON.parse(JSON.stringify(campaigns));
    data = data.map((c) => {
        delete c.Rules;
        return c;
    })
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${BASE_URL}/campaigns/order/save` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}